"use strict";
exports.__esModule = true;
exports.numeric = void 0;
var utils_1 = require("../../utils");
var factory_1 = require("../factory");
var validation_1 = require("../validation");
var numeric = function (messageKey, messageParams) {
    if (messageKey === void 0) { messageKey = 'invalid_number'; }
    if (messageParams === void 0) { messageParams = {}; }
    return function (field, obj) {
        var value = utils_1.Objects.path(field)(obj);
        var valid = utils_1.Objects.isEmpty(value) || !isNaN(value);
        return factory_1.ValidationResultFactory.createInstance({
            valid: valid,
            messageKey: messageKey,
            messageParams: messageParams,
            severity: validation_1.ValidationSeverity.error
        });
    };
};
exports.numeric = numeric;
//# sourceMappingURL=numeric.js.map